export default {
    parentAuthUser: null,
    authUserAbilities: [],
    authUserFeaturePreviews: [],
    users: {},
    contextAccountUsersAccountId: null,
};
